import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import _ from 'lodash';

import BreadCrumbMenu from '@/components/BreadCrumbMenus/';
import Placeholder from '@/components/Placeholder';
import { TABLET_P } from '@/constants';
import { getContent } from '@/services/api';
import { generateKey, makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import { contentTypeToUrl }from '@/pages/HomePage/KeyProductLine/KeyProductLine.style';

import LineHeader from './LineHeader';
import QuickLinksSection from '../../components/QuickLinksSection';
import Accordion from './Accordion';
import media from '../../styles/media.style';

const MainCover = styled.section`
  max-width: 1060px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 80px auto 150px;
`;
const CurrentNavCover = styled.section`
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: right;
  font-family: HiraginoUDSansStd-W6;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #000;
  cursor: pointer;
  > img {
    margin-right: 7px;
  }
  ${media.tabletP`
      padding: 0 20px!important;
  `}
  ${media.tabletL`
      padding: 0!important;
  `}
`;
const PlaceholderWrapper = styled.div`
  text-align: center;
`;
const PlaceholderColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 80px;
`;

/**
 * 商品情報画面 (/{locale}/range/{カテゴリ名}/{サブカテゴリ名}) の「取扱サロン一覧」ボタン押下後に表示される画面
 */
class SalonList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slug: undefined,
      product: undefined,
      linkId: undefined,
      salons: [],
      render: undefined,
      categoryKey: undefined,
      initPrefectures: false,
      // SEO 対策に必要なメタデータ
      siteOptionsMetaData: {},
    };
  }

  componentWillMount() {
    const { locale, location } = this.props;

    // TODO: コンポーネント初期ロード時に this.props.data.slug が取得出来ないため、location.pathname から slug を引き出しているが、要改善。
    if (locale && _.get(location, 'pathname')) {
      // SEO 対策に必要なメタデータを取得する
      getContent({ contentType: 'siteOptionsMetaData', locale, slug: location.pathname.split('/')[4] }).then(siteOptionsMetaData =>
        this.setState({ siteOptionsMetaData })
      );
    }
  }

  componentDidMount = () => {
    // const regexp = new RegExp(`^/${this.props.locale}/salon-list/([0-9a-zA-Z_-]+)$`);
    // const result = window.location.pathname.match(regexp);
    // if (result && result.length > 1) {
    //   this.setState({
    //     slug: result[1]
    //   });
    // }
    this.setData();
  };

  componentDidUpdate = (prevProps, prevState) => {
    // if (this.state.product === undefined) {
    //   const productData = this.props.data;
    //   if (Object.keys(productData).length > 0) {
    //     this.setState({product:{product:productData}});
    //   }
    //   //   const product = this.getProductData(this.state.slug, this.props.siteOptions.menu);
    //   //   if (product !== false ) {
    //   //     this.setState({ product });
    //   //   }
    // }

    this.setData();
  };

  setData = () => {
    if (this.state.product === undefined) {
      const productData = this.props.data;
      if (Object.keys(productData).length > 0) {
        this.setState({product:{product:productData}});
      }
    }

    if (this.state.categoryKey === undefined) {
      const category = this.getCategory(this.props.data.key, this.props.siteOptions.menu)
      if (category)
        this.setState({categoryKey: category});
    }

    if (this.props.prefectures !== undefined && !this.state.initPrefectures) {
      this.initPrefectures(this.props.prefectures);
    }

  }

  initPrefectures = (prefs) => {
    prefs.map(region =>
      region.prefectures.map(pref => {
        delete pref.isLoading;
        delete pref.salons;
      })
    )
    this.setState({initPrefectures: true});
  }

  getCategory = (key, globalMenus) => {

    if (key === undefined) return false;
    if (globalMenus === undefined) return false;

    const products = globalMenus.reduce((acc, menu) => {
      if (typeof menu.children !== 'undefined' && menu.children[0].contentType === 'siteOptionsProductCategory') {
        return [...acc, ...menu.children];
      }
      return acc;
    }, []);

    const subCategoryKeyMap = products.reduce((acc, category) => {
      return {...acc, ...category.children.reduce((acc2, subCategory) => {
          if (subCategory.contentType === 'siteOptionsProductSubcategory' && typeof subCategory.key !== 'undefined') {
            return {...acc2,[subCategory.key]:category.key};
          }
          return {...acc2};
        },{})}
    },{})

    const categoryKeyMap = products.reduce((acc, product) => {
      if (product.key){
        const mapObject = this.getLastChildrenNode(product.children).reduce((acc2,lastNode) => {
          if (lastNode.key) {
            return {...acc2,[lastNode.key]:product.key};
          }
          return {...acc2};
        },{});
        return {...acc, ...mapObject};
      }
      return {...acc};
    },{});

    const keyMap = {...subCategoryKeyMap, ...categoryKeyMap};

    if (Object.keys(keyMap).length > 0) {
      return keyMap[key];
    }
    return false;
  };

  getLastChildrenNode = children => {
    const hasChildrenNode = children.reduce(
      (acc, child) => (typeof child.children !== 'undefined' ? [...acc, ...child.children] : acc),
      []
    );
    let hasNotChildrenNode = children.reduce(
      (acc, child) => (typeof child.children === 'undefined' ? [...acc, child] : acc),
      []
    );
    if (hasChildrenNode.length > 0) {
      hasNotChildrenNode = hasNotChildrenNode.concat(this.getLastChildrenNode(hasChildrenNode));
    }
    return hasNotChildrenNode;
  };

  addSalonToPrefecture = (salons, regions, pref) => {
    regions.map(region => {
      region.prefectures.map(prefecture => {
        if (prefecture.prefecture === pref) {
          if (prefecture.salon === undefined) {
            prefecture['salons'] = salons;
            prefecture['isLoading'] = false;
          }
        }
      })
    })
  }

  stopLoading = (regions, pref) => {
    regions.map(region => {
      region.prefectures.map(prefecture => {
        if (prefecture.prefecture === pref) {
          if (prefecture.salon === undefined) {
            prefecture['isLoading'] = false;
            this.setState({render: new Date()})
          }
        }
      })
    })
  }

  hasSalon = pref => {
    let hasSalonData = false;
    this.props.prefectures.map(region => {
      region.prefectures.map(prefecture => {
        if (prefecture.prefecture === pref) {
          if (prefecture.salons) {
            hasSalonData = true;
            return true;
          }
        }
      })
    })
    return hasSalonData;
  }

  searchByPrefecture = (lineFilter, pref) => {
    const locale = this.props.locale;
    const has = this.hasSalon(pref);
    if(this.hasSalon(pref)) {
      this.stopLoading(this.props.prefectures, pref)
      return;
    }
    const encodedPref= encodeURIComponent(pref);
    getContent({ contentType: 'salon', lineFilter, locale, pref: encodedPref }).then(({ coords, salons }) => {
      this.addSalonToPrefecture(salons, this.props.prefectures, pref);
      this.setState({ salons }, () => {
        if (typeof callback === 'function') callback();
      });
    });
  };

  // getProductData = (slug, globalMenus) => {

  //   if (slug === undefined) return false;
  //   if (globalMenus === undefined) return false;

  //   const products = globalMenus.reduce((acc, menu) => {
  //     if (typeof menu.children !== 'undefined' && menu.children[0].contentType === 'siteOptionsProductCategory') {
  //       return [...acc, ...menu.children];
  //     }
  //     return acc;
  //   }, []);

  //   const targetProduct = this.getLastChildrenNode(products).filter(product => ( product.slug === slug && product ));

  //   if (targetProduct.length > 0) {
  //     return {product:targetProduct[0]};
  //   }
  //   return false;
  // };

  // getLastChildrenNode = children => {
  //   const hasChildrenNode = children.reduce(
  //     (acc, child) => (typeof child.children !== 'undefined' ? [...acc, ...child.children] : acc),
  //     []
  //   );
  //   let hasNotChildrenNode = children.reduce(
  //     (acc, child) => (typeof child.children === 'undefined' ? [...acc, child] : acc),
  //     []
  //   );
  //   if (hasChildrenNode.length > 0) {
  //     hasNotChildrenNode = hasNotChildrenNode.concat(this.getLastChildrenNode(hasChildrenNode));
  //   }
  //   return hasNotChildrenNode;
  // };

  static defaultProps = {
    prefectures: [],
  };

  static propTypes = {
    prefectures: PropTypes.arrayOf(PropTypes.shape()),
  };

  convertRegionData = prefectures => prefectures.map((region, i) => ({ id: `regions${i}`, label: region.region }));

  linkHandle = (linkId) => {
    this.setState({linkId})
  }

  render() {
    // Placeholder 表示に使用する
    const placeholderStart = 1;
    const placeholderEnd = 8;

    const { prefectures, locale, siteOptions, copy, menuInfo, data } = this.props;
    const { product, linkId, categoryKey, siteOptionsMetaData } = this.state;
    const regions = this.convertRegionData(prefectures && prefectures || []);

    // パンくずリスト表示用設定
    let categoryName = '';
    let subCategoryPath = '';
    _.forEach(_.get(menuInfo, 'children'), ({ label, children }) => {
      _.forEach(children, item => {
        if (label && _.get(data, 'slug') &&
          !!(!!(_.get(item, 'key') && item.key.replace(/ /, '-').toLowerCase() === data.slug.toLowerCase()) || !!(_.get(item, 'slug') && item.slug.replace(/ /, '-').toLowerCase() === data.slug.toLowerCase()))
        ) {
          categoryName = label.toUpperCase();

          if (_.get(item, 'url')) {
            subCategoryPath = `/${locale}${item.url}`;
          } else {
            subCategoryPath = `/${locale}/range/${label.toLowerCase().replace(/ /, '-')}/${_.get(data, 'slug')}`
          }
        }
      })
    });

    return (
      <React.Fragment>
        {_.get(data, 'slug') && (
          <Helmet
            link={[
              makeCanonicalTagObj(locale, `/salon-list/${contentTypeToUrl[data.contentType]}/${data.slug}`),
              ...makeHreflangTagArr(data.region, `/salon-list/${contentTypeToUrl[data.contentType]}/${data.slug}`)
            ]}
          />
        )}
        {_.get(siteOptionsMetaData, 'metaData') && (
          <Helmet
            title={_.get(siteOptionsMetaData.metaData, 'title')}
            meta={[
              {
                name: 'description',
                content: _.get(siteOptionsMetaData.metaData, 'description'),
              },
              {
                name: 'keyword',
                content: _.get(siteOptionsMetaData.metaData, 'keyword'),
              },
              // TODO: OGP タグは一旦保留 (2020年01月07日)
              // {
              //   property: 'og:url',
              //   content: _.get(siteOptionsMetaData.metaData, 'url'),
              // },
              // {
              //   property: 'og:type',
              //   content: _.get(siteOptionsMetaData.metaData, 'type'),
              // },
              // {
              //   property: 'og:title',
              //   content: _.get(siteOptionsMetaData.metaData, 'title'),
              // },
              // {
              //   property: 'og:image',
              //   content: _.get(siteOptionsMetaData.metaData, 'image.file.url'),
              // },
              // {
              //   property: 'og:description',
              //   content: _.get(siteOptionsMetaData.metaData, 'description'),
              // },
              // {
              //   property: 'og:site_name',
              //   content: _.get(siteOptionsMetaData.metaData, 'siteName'),
              // },
            ]}
          />
        )}
        {/* イメージ画像、見出し (サブカテゴリ、または LINE 表示部分)、「取り扱いサロン一覧」、「商品詳細はこちら」ボタン表示部分 */}
        <LineHeader product={product} />

        {/* 各地方へのページ内リンクボタン */}
        {!(prefectures && regions) ? (
          <PlaceholderWrapper>
            <Placeholder w={window.innerWidth > TABLET_P ? '100%' : '335px'} h={window.innerWidth > TABLET_P ? '55px' : '90px'} />
          </PlaceholderWrapper>
        ) : (
          <QuickLinksSection links={regions} linkHandle={this.linkHandle} />
        )}

        {/* 各地方 > 都道府県毎のリスト */}
        <MainCover>
          {/* <CurrentNavCover>
            <img src={pin} alt="" width="13" height="20" />
            {copy ? <Link to={`/${locale}/salon-locator#location`}>{copy.use_current_location}</Link> : ''}
          </CurrentNavCover> */}
          {!(product && prefectures && locale) ? (
            <PlaceholderColumn>
              {new Array(placeholderEnd - placeholderStart)
                .fill(null)
                .map((item, index) => (
                  <Placeholder w={window.innerWidth > TABLET_P ? '100%' : '100%'} h="48px" m="0 0 20px 0" key={generateKey('placeholder', index)} />
                ))}
            </PlaceholderColumn>
          ) : (
            <Accordion product={product} categoryKey={categoryKey} regions={prefectures} linkId={linkId} locale={locale} searchByPrefecture={this.searchByPrefecture} ref="accordion"/>
          )}
        </MainCover>

        {!(locale && menuInfo && _.get(menuInfo, 'label') && _.get(menuInfo, 'children') && _.get(copy, 'handle_salon_list') && _.get(product, 'product.name')) ? (
          <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
          ) : (
          <BreadCrumbMenu
            currentPath={`https://www.shiseido-professional.com/${locale}/salon-list/hair-care/sublimic`}
            items={[
              {
                name: 'TOP',
                path: `/${locale}/`,
              },
              // メニュー名を設定する (PRODUCTS)
              {
                name: menuInfo.label,
                path: null,
              },
              // カテゴリ名を設定する (例) HAIR CARE)
              {
                name: categoryName,
                path: null,
              },
              // サブカテゴリ名を設定する (例) SUBLIMIC)
              {
                name: product.product.name.toUpperCase(),
                path: subCategoryPath,
              },
              // 取り扱いサロン一覧
              {
                name: copy.handle_salon_list.toUpperCase(),
                path: null,
              },
            ]}
          />
        )}
      </React.Fragment>
    );
  }
}

SalonList.defaultProps = {
  data: {},
};

SalonList.propTypes = {
  locale: PropTypes.string.isRequired,
  // 商品情報 (パンくずリストに必要な情報を含む)
  menuInfo: PropTypes.shape({}).isRequired,
  data: PropTypes.shape(),
};

const mapState = state => ({
  locale: state.locale,
  // 商品情報をキャッシュしておく
  menuInfo: state.siteOptions.menu ? state.siteOptions.menu[3] : {},
  siteOptions: state.siteOptions,
  copy: state.siteOptions.siteCopySalonList,
  prefectures: state.siteOptions.prefectures,
  lines: state.siteOptions.menu,
});

export default connect(mapState)(SalonList);



// WEBPACK FOOTER //
// ./src/pages/SalonList/index.js